import type { SVGProps } from 'react';

const SvgUserAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.68 5h-2V3c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1m-6.14 8.01c.33-.42.61-.89.79-1.4a1 1 0 0 0-.6-1.28 1 1 0 0 0-1.28.6 2.96 2.96 0 0 1-2.77 1.95c-1.62 0-2.94-1.32-2.94-2.94S9.06 7 10.68 7c.55 0 1-.45 1-1s-.45-1-1-1C7.96 5 5.74 7.21 5.74 9.94A4.9 4.9 0 0 0 6.83 13a7.95 7.95 0 0 0-4.16 7c0 .55.45 1 1 1s1-.45 1-1c0-2.53 1.56-4.73 3.91-5.61.64.3 1.34.48 2.09.48s1.45-.17 2.1-.48c2.34.87 3.9 3.07 3.9 5.6 0 .55.45 1 1 1s1-.45 1-1c0-2.98-1.62-5.61-4.14-6.99z"
    />
  </svg>
);
export default SvgUserAdd;
